import { loadTemplate } from '../template/index.js';
import { handleSearch, handleInitialLoad } from './handlers.js';

/**
 * Initialize Video Category List Module
 */
export async function initVideoCategoryList() {
	const container = document.getElementById('video-list-container');
	const searchInput = document.querySelector('input[name="video-search"]');

	if (!container) return;

	// Load templates
	await Promise.all([
		loadTemplate('video-category/item.ejs'),
		loadTemplate('video-category/list.ejs'),
		loadTemplate('video-category/empty.ejs')
	]);

	// Initial load
	await handleInitialLoad(container);

	// Setup search listener
	if (searchInput) {
		searchInput.addEventListener('input', (e) => handleSearch(e, container));
	}
}
